import { render } from "./pnc_visit.vue?vue&type=template&id=d6d8dd80&scoped=true"
import script from "./pnc_visit.vue?vue&type=script&lang=js"
export * from "./pnc_visit.vue?vue&type=script&lang=js"

import "./pnc_visit.vue?vue&type=style&index=0&id=d6d8dd80&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6d8dd80"]])

export default __exports__